<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "ArchivedCardsDialog",
  props: {
    qrId: {
      type: [Number, String],
      required: true,
      default: 0,
    },
    archivedCardsCount: Number,
  },
  data() {
    return {
      dialog: false,
      list: [],
      loading: false,
      restoringId: null,
      cons: { title: "لیست کارت های بایگانی" },
    };
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    // این متد توسط کامپوننت پدر صدا زده می‌شود
    open() {
      this.dialog = true;
      this.fetchData();
      console.log(this.dialog);
    },

    fetchData() {
      this.loading = true;
      this.$api
        .get("/v1/testQr/smart/archived", {
          params: { qr_id: this.qrId },
        })
        .then((res) => {
          console.log(res.data.data.length);
          this.list = res.data.data || [];
          this.$emit("update:archivedCardsCount", this.list.length);
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("خطا در دریافت لیست بایگانی");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    restoreCard(card) {
      this.restoringId = card.id;

      const payload = {
        is_active: true,
        is_archived: false,
      };
      // فرض بر این است که روت بازگردانی به این صورت است. در صورت نیاز تغییر دهید
      this.$api
        .post(
          `/v1/testQr/smart/account/state/${card.id}?qr_id=${this.qrId}`,
          payload
        )
        .then(() => {
          this.$toast.success("کارت با موفقیت بازیابی شد.");
          this.fetchData();
          // ارسال رویداد به پدر برای آپدیت کردن لیست اصلی
          this.$emit("restored", card);
        })
        .catch((err) => {
          this.$toast.error("خطا در بازیابی کارت");
        })
        .finally(() => {
          this.restoringId = null;
        });
    },

    formatCardNumber(value) {
      if (!value) return "";
      const rawValue = value.toString().replace(/\D/g, "");
      const truncated = rawValue.slice(0, 16);
      return truncated.replace(/(\d{4})/g, "$1 ").trim();
    },
  },
});
</script>

<template>
  <div>
    <custom-popup
      id="add-archive-card"
      v-model="dialog"
      :cons="cons"
      max-width="800"
      :hideConfirm="true"
      :persistent="true"
    >
      <v-card>
        <v-card-text style="height: 400px" class="pt-4">
          <div v-if="loading" class="text-center my-10">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
            <div class="mt-2 text-caption">در حال دریافت...</div>
          </div>

          <div
            v-else-if="list.length === 0"
            class="text-center grey--text my-10"
          >
            <v-icon size="50" color="grey lighten-2">mdi-archive-off</v-icon>
            <div class="mt-2">لیست بایگانی خالی است.</div>
          </div>

          <v-row v-else>
            <v-col v-for="card in list" :key="card.id" cols="12">
              <v-card outlined class="pa-3 grey lighten-5">
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <div class="font-weight-bold">{{ card.bank_name }}</div>
                    <div class="text-caption grey--text" dir="ltr">
                      {{ formatCardNumber(card.cart_number) }}
                    </div>
                    <div class="text-caption mt-1">
                      {{ card.owner_name }}
                    </div>
                  </div>

                  <v-btn
                    color="info"
                    small
                    depressed
                    :loading="restoringId === card.id"
                    @click="restoreCard(card)"
                  >
                    <v-icon left small>mdi-refresh</v-icon>
                    بازگردانی
                  </v-btn>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </custom-popup>
  </div>
</template>
